import PhoneInput from "react-phone-number-input";

interface Props {
	value: string;
	onChange: (value?: string) => void;
}

const PhoneNumberInput = (props: Props): JSX.Element => {
	const { value, onChange } = props;

	return (
		<div className="h-[60px] w-full bg-[#757575] rounded-[55px] flex">
			<PhoneInput
				className="PhoneInput"
				placeholder="Phone Number"
				value={value}
				onChange={onChange}
			/>
		</div>
	);
};

export default PhoneNumberInput;
